import { render, staticRenderFns } from "./WSManager.vue?vue&type=template&id=3387fe92&"
import script from "./WSManager.vue?vue&type=script&lang=js&"
export * from "./WSManager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports